import { Component, OnInit, Input } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';

@Component({
  selector: 'app-type-selector',
  templateUrl: './type-selector.component.html',
  styleUrls: ['./type-selector.component.less']
})
export class TypeSelectorComponent implements OnInit {

  types: any;
  selected: any;
  title: string;
  @Input() relatieid: number;

  constructor(private relatiesService: RelatiesService) {

    this.relatiesService.getRelatieTypes().subscribe(data => {
      this.types = data;
      this.generateTitle();
      //alert(JSON.stringify(this.branches[0].BrancheNaam))
    });

  }
  ngOnInit() {
    this.relatiesService.getRelatieRelatieTypes(this.relatieid).subscribe(data => {
      this.selected = data;
      this.generateTitle();
      //alert(JSON.stringify(this.branches[0].BrancheNaam))
    });
  }

  generateTitle() {
    if (this.selected == null || this.types == null) return;
    let title: string = '';
    this.selected.forEach(sel => {
      this.types.forEach(e => {
        if (e.TypeID == sel.RelatieTypeID) {
            if (title != "") title += ", ";
            title += e.Omschrijving ;
        }
      })
    })
    this.title = title;

  }

  isSelected(id: number) {
    let found: boolean = false;
    this.selected.forEach(element => {
      if (element.RelatieTypeID == id) {
        found = true;
      }
    });
    return found ;
  }


  changeStatus(id,event) {
    if (event.target.checked) {
        this.relatiesService.addRelatieType(this.relatieid,id).subscribe();
        this.selected.push({
          RelatieTypeID: id
        })
    } else {
      this.relatiesService.deleteRelatieType(this.relatieid,id).subscribe();
      this.selected.forEach( (item, index) => {
        if(item.RelatieTypeID === id) {
          this.selected.splice(index,1);
        }
    });

    }
    this.generateTitle();
  }



}
